import { FC } from "react";

import "./sentry-instrument";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { AuthProvider } from "@/auth/AuthProvider";
import useAuthentication from "@/auth/useAuthentication";

import { Satos } from "@/components/Application/Satos";
import { TimeProvider } from "@/components/Application/TimeContext";

import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

interface Props {
	children: React.ReactNode;
}

const AuthenticatedUser: FC<Props> = (props) => {
	const context = useAuthentication();

	if (context?.isAuthflowCompleted) {
		if (context.isAuthenticated) {
			return <>{props.children}</>;
		} else if (!context.isFetching && !context.isAuthenticated) {
			context.login(window.location.href, []);
			process.env.ENVIRONMENT;
		}
	}

	return <></>;
};
const queryClient = new QueryClient();

const App = () => {
	return (
		<AuthProvider>
			<QueryClientProvider client={queryClient}>
				<AuthenticatedUser>
					<Satos />
				</AuthenticatedUser>
				<ReactQueryDevtools initialIsOpen={false} />
			</QueryClientProvider>
		</AuthProvider>
	);
};

export default App;
